export const getContentInHtml = (doc: string): string[] => {
  const parser: DOMParser = new DOMParser();
  const document: Document = parser.parseFromString(doc, 'text/html');

  const stk: any = document.querySelector('meta[name="stk"]');
  const route: any = document.querySelector('meta[name="route"]');

  return [stk?.content, route?.content];
};
